import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { AppDispatch } from '../../../store';
import { Steps, Card } from 'antd';
import Define from './Define/Define';
import AddFindingTypes from './AddFindingTypes/AddFindingTypes';
import Rules from './Rules/Rules';
import Finish from './Finish/Finish';
import styles from './AnnotationStandardForm.module.scss';
import {
  getFindingTypeTemplates,
  resetState,
  loadAnnotationStandard,
  setClonedUrl,
  getFailureMechanismTemplates,
  getFailureModeCategoryTemplates,
  getEightDTemplates
} from './AnnotationStandardForm.slice';
import { RouteComponentProps } from 'react-router-dom';
import Busy from '../../Shared/Busy';

const { Step } = Steps;

const steps = [
  {
    title: 'Define annotation standard',
    content: <Define />
  },
  {
    title: 'Add finding types',
    content: <AddFindingTypes />
  },
  {
    title: 'Define rules',
    content: <Rules />
  },
  {
    title: 'Finish',
    content: <Finish />
  }
];

type Props = {
  currentPage: number;
  isStandardLoading: boolean;
  clonedUrl: string;
  onGetFindingTypeTemplates: () => void;
  onGetFailureMechanismTemplates: () => void;
  onGetFailureModeCategoryTemplates: () => void;
  onGetEightDTemplates: () => void;
  resetState: () => void;
  loadStandard: (id: string) => void;
  setClonedUrl: (url: string) => void;
};

const AnnotationStandardCreation: FC<RouteComponentProps<{ id: string }> & Props> = ({
  match,
  history,
  onGetFindingTypeTemplates,
  currentPage,
  resetState,
  isStandardLoading,
  loadStandard,
  clonedUrl,
  setClonedUrl,
  onGetFailureMechanismTemplates,
  onGetFailureModeCategoryTemplates,
  onGetEightDTemplates
}) => {
  useEffect(() => {
    onGetFindingTypeTemplates();
    onGetFailureMechanismTemplates();
    onGetFailureModeCategoryTemplates();
    onGetEightDTemplates();
  }, [onGetFailureMechanismTemplates, onGetFindingTypeTemplates]);

  useEffect(() => {
    resetState();

    const { id } = match.params;

    loadStandard(id);

    return () => {
      resetState();
    };
  }, [loadStandard, match.params, resetState]);

  if (clonedUrl.length) {
    setClonedUrl('');
    history.push(clonedUrl);
    window.history.go();
    resetState();
    return <Busy />;
  }

  if (isStandardLoading) {
    return (
      <div className={styles.creationContainer}>
        <Busy />
      </div>
    );
  }

  return (
    <div className={styles.creationContainer}>
      <Card style={{ margin: '0 auto' }}>
        <Steps current={currentPage} className='stepsComponent'>
          {steps.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className={styles.stepsContent}>{steps[currentPage].content}</div>
      </Card>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  currentPage: state.annotationStandardForm.currentPage,
  isStandardLoading: state.annotationStandardForm.standardIsLoading,
  clonedUrl: state.annotationStandardForm.clonedUrl
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onGetFindingTypeTemplates: () => dispatch(getFindingTypeTemplates()),
  onGetFailureMechanismTemplates: () => dispatch(getFailureMechanismTemplates()),
  onGetFailureModeCategoryTemplates: () => dispatch(getFailureModeCategoryTemplates()),
  onGetEightDTemplates: () => dispatch(getEightDTemplates()),
  resetState: () => dispatch(resetState()),
  loadStandard: (id: string) => dispatch(loadAnnotationStandard(id)),
  setClonedUrl: (url: string) => dispatch(setClonedUrl(url))
});

export default connect(mapStateToProps, mapDispatchToProps)(AnnotationStandardCreation);
